module.exports = __webpack_public_path__ + "static/media/toolbarLogo.e004f077.png";